
const FILTER_SELECTORS = {
    products: '.products',
    filters: '.facet-filters',
    filtersContent: '.facet-filters .facet-filters-filters',
    filtersCount: '.facet-filters .facet-filters-count',
    sectionProducts: '.section-products',
    filterForm: '.filter-form'
};

function getInfiniteProductsSection() {
    return document.querySelector('.products[data-infinite-scroll="true"]');
}

function getInfiniteScrollStateKey(url = window.location.pathname + window.location.search) {
    return `vitamine:infinite-scroll:${url}`;
}

function saveInfiniteScrollState() {
    var productsSection = getInfiniteProductsSection();

    if( !productsSection ){
        return;
    }

    var clickedProductPath = sessionStorage.getItem(`${getInfiniteScrollStateKey()}:clicked-product`) || '';

    sessionStorage.setItem(getInfiniteScrollStateKey(), JSON.stringify({
        html: productsSection.innerHTML,
        scrollY: window.scrollY || window.pageYOffset || 0,
        clickedProductPath
    }));
}

function restoreInfiniteScrollState() {
    var productsSection = getInfiniteProductsSection();

    if( !productsSection ){
        return;
    }

    var navigationEntries = performance.getEntriesByType('navigation');
    var navigationType = navigationEntries.length ? navigationEntries[0].type : '';

    if( navigationType !== 'back_forward' ){
        return;
    }

    var savedState = sessionStorage.getItem(getInfiniteScrollStateKey());

    if( !savedState ){
        return;
    }

    try {
        var parsedState = JSON.parse(savedState);

        if( parsedState && parsedState.html ){
            productsSection.innerHTML = parsedState.html;
        }

        var restorePosition = () => {
            var targetY = parsedState.scrollY || 0;

            if( parsedState.clickedProductPath ){
                var targetLink = productsSection.querySelector(`a[href*="${parsedState.clickedProductPath}"]`);
                var targetItem = targetLink ? targetLink.closest('.products-list-item') : null;

                if( targetItem ){
                    targetY = targetItem.getBoundingClientRect().top + window.scrollY - 24;
                }
            }

            window.scrollTo(0, Math.max(targetY, 0));
        };

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                restorePosition();
                window.setTimeout(restorePosition, 80);
            });
        });
    }
    catch (error) {
        sessionStorage.removeItem(getInfiniteScrollStateKey());
    }
}

function bindInfiniteScrollStateTracking() {
    var productsSection = getInfiniteProductsSection();

    if( !productsSection || productsSection.dataset.stateTrackingBound === 'true' ){
        return;
    }

    productsSection.dataset.stateTrackingBound = 'true';

    productsSection.addEventListener('click', (event) => {
        var productLink = event.target.closest('.products-list-item a[href]');

        if( !productLink ){
            return;
        }

        try {
            var productUrl = new URL(productLink.href, window.location.origin);
            sessionStorage.setItem(`${getInfiniteScrollStateKey()}:clicked-product`, productUrl.pathname);
        }
        catch (error) {
            sessionStorage.setItem(`${getInfiniteScrollStateKey()}:clicked-product`, productLink.getAttribute('href'));
        }
    });

    if( !window.__vitamineInfiniteScrollStateBound ){
        window.addEventListener('pagehide', saveInfiniteScrollState);
        window.__vitamineInfiniteScrollStateBound = true;
    }
}

function updateURLState(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
}

function createSearchParamsFromString(search = window.location.search) {
    var searchString = `${search || ''}`.replace(/^\?/, '');
    return new URLSearchParams(searchString);
}

function buildMergedSearchParams(currentParams, controlledKeys, replacementParams, ignoredKeys = ['page']) {
    var mergedParams = new URLSearchParams(currentParams.toString());

    for( let ignoredKey of ignoredKeys ){
        mergedParams.delete(ignoredKey);
    }

    for( let controlledKey of controlledKeys ){
        mergedParams.delete(controlledKey);
    }

    for( let [key, value] of replacementParams.entries() ){
        if( value !== '' ){
            mergedParams.append(key, value);
        }
    }

    return mergedParams.toString();
}

function fetchSectionMarkup(sectionId, searchParams = '') {
    var requestUrl = new URL(window.location.pathname, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);

    var nextParams = createSearchParamsFromString(searchParams);

    for( let [key, value] of nextParams.entries() ){
        requestUrl.searchParams.append(key, value);
    }

    return fetch(requestUrl.toString()).then((response) => response.text());
}

function createMarkupFragment(text) {
    const html = document.createElement('div');
    html.innerHTML = text;
    return html;
}

function updatePagination(searchParams){
    var paginationLinks = document.querySelectorAll('.products-pagination a');

    var existingSearchParams = new URLSearchParams(searchParams);

    for( let link of paginationLinks ){

        var searchParamsArray = {};
        var urlBase = link.getAttribute('href').split('?')[0];
        var url = link.getAttribute('href').split('?')[1];
        var urlParams = new URLSearchParams(url);
       
        for(const entry of urlParams.entries()) {
            searchParamsArray[entry[0]] = entry[1];
        }

        for(const existingEntry of existingSearchParams.entries()){
            searchParamsArray[decodeURIComponent(existingEntry[0])] = decodeURIComponent(existingEntry[1]);
        }

        var newUrlParams = new URLSearchParams(searchParamsArray).toString();
        var newUrl = urlBase + '?' + newUrlParams;

        link.setAttribute('href', newUrl)
    }


}


// Filters & Sorting
class ProductFilters extends HTMLElement{
    constructor(){
        super();

        this.handleRootClick = this.handleRootClick.bind(this);
        this.handleRootSubmit = this.handleRootSubmit.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
        this.handlePointerMove = this.onMove.bind(this);
        this.handlePointerUp = this.onMouseUp.bind(this);

        this.filterAnimationDuration = 280;
        this._connected = false;
        this._priceSliderDocumentBound = false;
    }

    connectedCallback(){
        if( this._connected ){
            return;
        }

        this._connected = true;

        this.addEventListener('click', this.handleRootClick);
        this.addEventListener('submit', this.handleRootSubmit);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleDocumentKeydown);

        this.priceRangeSlider();
    }

    disconnectedCallback(){
        if( !this._connected ){
            return;
        }

        this._connected = false;

        this.removeEventListener('click', this.handleRootClick);
        this.removeEventListener('submit', this.handleRootSubmit);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        this.teardownPriceRangeSlider();
    }

    getForm = () => {
        return this.querySelector(FILTER_SELECTORS.filterForm);
    }

    getTitleButton = () => {
        return this.querySelector('.facet-filters-title');
    }

    openDrawer = () => {
        var form = this.getForm();
        var titleButton = this.getTitleButton();

        if( !form ){
            return;
        }

        form.classList.add('active');
        this.classList.add('is-drawer-open');

        if( titleButton ){
            titleButton.setAttribute('aria-expanded', 'true');
        }

        document.documentElement.classList.add('facet-filters-open', 'overflow-hidden');
        document.body.classList.add('facet-filters-open', 'overflow-hidden');
    }

    closeDrawer = () => {
        var form = this.getForm();
        var titleButton = this.getTitleButton();

        if( form ){
            form.classList.remove('active');
        }

        this.classList.remove('is-drawer-open');

        if( titleButton ){
            titleButton.setAttribute('aria-expanded', 'false');
        }

        document.documentElement.classList.remove('facet-filters-open', 'overflow-hidden');
        document.body.classList.remove('facet-filters-open', 'overflow-hidden');
    }

    handleRootClick = (event) => {
        var target = event.target instanceof Element ? event.target : null;

        if( !target ){
            return;
        }

        if( target.closest('.facet-filters-title') ){
            event.preventDefault();
            this.openDrawer();
            return;
        }

        if( target.closest('.facet-filters-list-close, .facet-filters-overlay') ){
            event.preventDefault();
            this.closeDrawer();
            return;
        }

        var filterSummary = target.closest('.filter-group-summary');

        if( filterSummary ){
            event.preventDefault();
            this.toggleFilterGroup(filterSummary.closest('.filter-group'));
            return;
        }

        if( target.closest('button[type="submit"]') ){
            event.preventDefault();
            this.ajaxFiltering(event);
        }
    }

    handleRootSubmit = (event) => {
        if( event.target instanceof HTMLFormElement && event.target.classList.contains('filter-form') ){
            event.preventDefault();
            this.ajaxFiltering(event);
        }
    }

    handleDocumentClick = (event) => {
        var target = event.target instanceof Element ? event.target : null;
        var details = this.getElementsByTagName('details');

        for(let detail of details){
            if( target !== detail && !detail.contains(target) ){
                this.closeFilterGroup(detail);
            }
        }
    }

    handleDocumentKeydown = (event) => {
        if( event.key === 'Escape' ){
            this.closeDrawer();
        }
    }

    getFilterFieldNames = () => {
        var form = this.getForm();
        var fieldNames = new Set();

        if( !form ){
            return [];
        }

        for( let element of form.querySelectorAll('[name]') ){
            if( element.name ){
                fieldNames.add(element.name);
            }
        }

        return [...fieldNames];
    }

    getParams = () => {
        var form = this.getForm();

        if( !form ){
            return '';
        }

        var currentParams = createSearchParamsFromString(window.location.search);
        var replacementParams = new URLSearchParams(new FormData(form));
        var controlledKeys = this.getFilterFieldNames();

        return buildMergedSearchParams(currentParams, controlledKeys, replacementParams);
    }

    ajaxFiltering = (event) => {
        var searchParams = this.getParams();
        var productsSection = document.querySelector(FILTER_SELECTORS.products);
        var filtersSection = document.querySelector(FILTER_SELECTORS.filters);

        if( !productsSection || !filtersSection ){
            return;
        }

        var productsSectionId = productsSection.dataset.id;
        var filtersSectionId = filtersSection.dataset.id;

        Promise.all([
            fetchSectionMarkup(filtersSectionId, searchParams),
            fetchSectionMarkup(productsSectionId, searchParams)
        ]).then(([filtersMarkup, productsMarkup]) => {
            this.insertFilteredFacets(filtersMarkup);
            this.insertFilteredProducts(productsMarkup);

            updateURLState(searchParams);
            this.closeDropdown(event);
            this.closeDrawer();
        });
    }

    closeDropdown = (event) => {
        var detail = event.target.closest('details')
        if( detail ){
            detail.removeAttribute('open');
        }
    }

    insertFilteredFacets = (text) => {
        var filtersSection = document.querySelector(FILTER_SELECTORS.filtersContent);
        var filtersCountSection = document.querySelector(FILTER_SELECTORS.filtersCount);
        const html = createMarkupFragment(text);
        const newFiltersSection = html.querySelector(FILTER_SELECTORS.filtersContent);
        const newFiltersCountSection = html.querySelector(FILTER_SELECTORS.filtersCount);

        if( !filtersSection || !newFiltersSection ){
            return;
        }

        filtersSection.innerHTML = newFiltersSection.innerHTML;

        if( filtersCountSection && newFiltersCountSection ){
            filtersCountSection.innerHTML = newFiltersCountSection.innerHTML;
        }

        this.closeDrawer();
        this.priceRangeSlider();
    }

    insertFilteredProducts = (text) => {
        var productsSection = document.querySelector(FILTER_SELECTORS.products);
        const html = createMarkupFragment(text);
        const newProductsSection = html.querySelector(FILTER_SELECTORS.products);

        if( !productsSection || !newProductsSection ){
            return;
        }

        productsSection.innerHTML = newProductsSection.innerHTML;
        bindInfiniteScrollStateTracking();
        saveInfiniteScrollState();
    }

    toggleFilterGroup = (group) => {
        if( !group || group.dataset.animating === 'true' ){
            return;
        }

        if( group.hasAttribute('open') && !group.classList.contains('is-closing') ){
            this.closeFilterGroup(group);
            return;
        }

        this.openFilterGroup(group);
    }

    openFilterGroup = (group) => {
        if( !group ){
            return;
        }

        group.dataset.animating = 'true';
        group.classList.remove('is-closing');
        group.setAttribute('open', '');

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                group.classList.add('is-opening');

                window.setTimeout(() => {
                    group.classList.remove('is-opening');
                    group.dataset.animating = 'false';
                }, this.filterAnimationDuration);
            });
        });
    }

    closeFilterGroup = (group) => {
        if( !group || !group.hasAttribute('open') || group.dataset.animating === 'true' && group.classList.contains('is-closing') ){
            return;
        }

        group.dataset.animating = 'true';
        group.classList.remove('is-opening');
        group.classList.add('is-closing');

        window.setTimeout(() => {
            group.classList.remove('is-closing');
            group.removeAttribute('open');
            group.dataset.animating = 'false';
        }, this.filterAnimationDuration);
    }

    priceRangeSlider = () => {
        this.isDraggingMin = false;
        this.isDraggingMax = false;

        this.handle = this.querySelector('.filter-group-display__price-range-slider');
        this.handleMin = this.querySelector('.filter-group-display__price-range-slider-handle--min');
        this.handleMax = this.querySelector('.filter-group-display__price-range-slider-handle--max');

        this.minPriceElement = this.querySelector('.filter-group-display__price-range-from input[type="number"]');
        this.maxPriceElement = this.querySelector('.filter-group-display__price-range-to input[type="number"]');

        if( !this.handle || !this.handleMin || !this.handleMax || !this.minPriceElement || !this.maxPriceElement ){
            return;
        }

        this.minPrice = this.parsePriceNumber(this.minPriceElement.getAttribute('min'), 0);
        this.maxPrice = this.parsePriceNumber(this.maxPriceElement.getAttribute('max'), 0);

        if( !Number.isFinite(this.maxPrice) || this.maxPrice <= this.minPrice ){
            this.maxPrice = this.parsePriceNumber(this.maxPriceElement.getAttribute('placeholder'), this.maxPrice);
        }

        if( !Number.isFinite(this.maxPrice) || this.maxPrice <= this.minPrice ){
            var sliderSummary = this.querySelector('.filter-group-display__price-range > span');
            var priceMatches = sliderSummary ? sliderSummary.textContent.match(/\d+(?:[.,]\d+)?/g) : null;

            if( priceMatches && priceMatches.length ){
                this.maxPrice = Math.max(...priceMatches.map((value) => this.parsePriceNumber(value, 0)));
            }
        }

        this.priceRange = Math.max(this.maxPrice - this.minPrice, 0);

        this.minPriceElement.setAttribute('max', this.maxPrice);
        this.maxPriceElement.setAttribute('max', this.maxPrice);

        if( this.handle.dataset.sliderBound === 'true' ){
            this.syncPriceRangeSlider();
            return;
        }

        this.handle.dataset.sliderBound = 'true';

        this.handleMin.addEventListener('mouseup', () => { this.isDraggingMin = false });
        this.handleMin.addEventListener('mousedown', () => { this.isDraggingMin = true });
        this.handleMax.addEventListener('mouseup', () => { this.isDraggingMax = false });
        this.handleMax.addEventListener('mousedown', () => { this.isDraggingMax = true });

        this.handleMin.addEventListener('touchend', () => { this.isDraggingMin = false });
        this.handleMin.addEventListener('touchstart', () => { this.isDraggingMin = true });
        this.handleMax.addEventListener('touchend', () => { this.isDraggingMax = false });
        this.handleMax.addEventListener('touchstart', () => { this.isDraggingMax = true });

        this.minPriceElement.addEventListener('input', () => this.syncPriceRangeSliderFromInputs('min'));
        this.maxPriceElement.addEventListener('input', () => this.syncPriceRangeSliderFromInputs('max'));

        if( !this._priceSliderDocumentBound ){
            document.addEventListener('mousemove', this.handlePointerMove);
            document.addEventListener('touchmove', this.handlePointerMove);
            document.addEventListener('mouseup', this.handlePointerUp);
            document.addEventListener('touchend', this.handlePointerUp);
            this._priceSliderDocumentBound = true;
        }

        this.syncPriceRangeSlider();
    }

    parsePriceNumber = (value, fallbackValue = NaN) => {
        var normalizedValue = `${value ?? ''}`.trim();

        if( !normalizedValue.length ){
            return fallbackValue;
        }

        normalizedValue = normalizedValue
            .replace(/\u00a0/g, '')
            .replace(/\s+/g, '')
            .replace(/[^0-9,.-]/g, '');

        var lastComma = normalizedValue.lastIndexOf(',');
        var lastDot = normalizedValue.lastIndexOf('.');

        if( lastComma !== -1 && lastDot !== -1 ){
            if( lastComma > lastDot ){
                normalizedValue = normalizedValue.replace(/\./g, '').replace(',', '.');
            }
            else{
                normalizedValue = normalizedValue.replace(/,/g, '');
            }
        }
        else if( lastComma !== -1 ){
            normalizedValue = normalizedValue.replace(',', '.');
        }

        var parsedValue = parseFloat(normalizedValue);
        return Number.isFinite(parsedValue) ? parsedValue : fallbackValue;
    }

    onMove = (e) => {
        if( !(this.isDraggingMax == true || this.isDraggingMin == true) ){
            return false;
        }
        var pointerX = e.pageX;

        if( e.type === 'touchmove' ){
            var touch = e.touches[0] || e.changedTouches[0];
            pointerX = touch.pageX;
        }

        var rect = this.handle.getBoundingClientRect();
        var sliderLeft = rect.left + window.scrollX;
        var sliderWidth = rect.width;

        if( !sliderWidth ){
            return;
        }

        var relativeX = Math.min(Math.max(pointerX - sliderLeft, 0), sliderWidth);
        var percentage = relativeX / sliderWidth;
        var rawValue = this.minPrice + (this.priceRange * percentage);
        var value = Math.round(rawValue);

        var currentMinValue = this.getPriceInputValue(this.minPriceElement, this.minPrice);
        var currentMaxValue = this.getPriceInputValue(this.maxPriceElement, this.maxPrice);

        if( this.isDraggingMin ){
            value = Math.min(value, currentMaxValue);
            this.minPriceElement.value = value;
        }

        if( this.isDraggingMax ){
            value = Math.max(value, currentMinValue);
            this.maxPriceElement.value = value;
        }

        this.syncPriceRangeSlider();

    }

    onMouseUp = () => {
        this.isDraggingMin = false;
        this.isDraggingMax = false;

    }

    teardownPriceRangeSlider = () => {
        if( !this._priceSliderDocumentBound ){
            return;
        }

        document.removeEventListener('mousemove', this.handlePointerMove);
        document.removeEventListener('touchmove', this.handlePointerMove);
        document.removeEventListener('mouseup', this.handlePointerUp);
        document.removeEventListener('touchend', this.handlePointerUp);
        this._priceSliderDocumentBound = false;
    }

    getPriceInputValue = (input, fallbackValue) => {
        return this.parsePriceNumber(input.value, fallbackValue);
    }

    syncPriceRangeSliderFromInputs = (source) => {
        var minValue = this.getPriceInputValue(this.minPriceElement, this.minPrice);
        var maxValue = this.getPriceInputValue(this.maxPriceElement, this.maxPrice);

        minValue = Math.max(this.minPrice, Math.min(minValue, this.maxPrice));
        maxValue = Math.max(this.minPrice, Math.min(maxValue, this.maxPrice));

        if( source === 'min' && minValue > maxValue ){
            maxValue = minValue;
            this.maxPriceElement.value = maxValue;
        }

        if( source === 'max' && maxValue < minValue ){
            minValue = maxValue;
            this.minPriceElement.value = minValue;
        }

        this.minPriceElement.value = minValue === this.minPrice && this.minPriceElement.value === '' ? '' : minValue;
        this.maxPriceElement.value = maxValue === this.maxPrice && this.maxPriceElement.value === '' ? '' : maxValue;

        this.syncPriceRangeSlider();
    }

    syncPriceRangeSlider = () => {
        var minValue = this.getPriceInputValue(this.minPriceElement, this.minPrice);
        var maxValue = this.getPriceInputValue(this.maxPriceElement, this.maxPrice);

        minValue = Math.max(this.minPrice, Math.min(minValue, this.maxPrice));
        maxValue = Math.max(minValue, Math.min(maxValue, this.maxPrice));

        var minPercent = this.priceRange > 0 ? ((minValue - this.minPrice) / this.priceRange) * 100 : 0;
        var maxPercent = this.priceRange > 0 ? ((maxValue - this.minPrice) / this.priceRange) * 100 : 100;

        this.handleMin.style.width = `${minPercent}%`;
        this.handleMax.style.width = `${maxPercent}%`;
    }
}
if( !customElements.get('facet-filters') ){
    customElements.define('facet-filters', ProductFilters);
}



class SortingDropdown extends HTMLElement{
    constructor(){
        super();

        this.handleToggleClick = this.onClick.bind(this);
        this.handleDocumentClick = this.onDocumentClick.bind(this);
        this.handleNativeSelectChange = this.onNativeSelectChange.bind(this);
        this._connected = false;
    }

    connectedCallback(){
        if( this._connected ){
            return;
        }

        this._connected = true;
        this.dropdownToggle = this.querySelector('.facet-filters-sorting-default');
        this.dropdownCurrent = this.querySelector('.facet-filters-sorting-current');
        this.sortOptions = [...this.querySelectorAll('li')];
        this.nativeSelect = this.parentElement ? this.parentElement.querySelector('.facet-filters-sorting-select') : null;

        if( this.dropdownToggle ){
            this.dropdownToggle.addEventListener('click', this.handleToggleClick);
        }

        document.addEventListener('click', this.handleDocumentClick);

        for( let option of this.sortOptions ){
            option.addEventListener('click', () => {
                this.onOptionClick(option);
            });
        }

        if( this.nativeSelect ){
            this.nativeSelect.addEventListener('change', this.handleNativeSelectChange);
        }
    }

    disconnectedCallback(){
        if( !this._connected ){
            return;
        }

        this._connected = false;

        if( this.dropdownToggle ){
            this.dropdownToggle.removeEventListener('click', this.handleToggleClick);
        }

        document.removeEventListener('click', this.handleDocumentClick);

        if( this.nativeSelect ){
            this.nativeSelect.removeEventListener('change', this.handleNativeSelectChange);
        }
    }

    onDocumentClick = (event) => {
        if( event.target !== this && !this.contains(event.target) ){
            this.close();
        }
    }

    onClick = () => {
        if( this.classList.contains('active') ){
            this.close();
        }
        else{
            this.open();
        }
    }

    open = () => {
        this.classList.add('active');
    }

    close = () => {
        this.classList.remove('active');
    }

    onOptionClick = (option) => {
        var value = option.dataset.value;
        this.updateSorting(value);
    }

    onNativeSelectChange = () => {
        if( !this.nativeSelect ){
            return;
        }

        this.updateSorting(this.nativeSelect.value);
    }

    updateSorting = (value) => {
        var queryParams = createSearchParamsFromString(window.location.search);
        queryParams.delete('page');
        queryParams.set('sort_by', value);
        this.ajaxSorting(queryParams);
    }

    ajaxSorting = (queryParams) => {
        var productsSection = document.querySelector(FILTER_SELECTORS.products);

        if( !productsSection ){
            return;
        }

        var productsSectionId = productsSection.dataset.id;
        var searchParams = queryParams.toString();

        fetchSectionMarkup(productsSectionId, searchParams)
        .then((text) => {

            for( let option of this.sortOptions ){
                option.classList.toggle('selected', option.dataset.value == queryParams.get('sort_by'));

                if( option.dataset.value == queryParams.get('sort_by') && this.dropdownCurrent ){
                    this.dropdownCurrent.textContent = option.textContent.trim();
                }
            }

            if( this.nativeSelect ){
                this.nativeSelect.value = queryParams.get('sort_by');
            }

            const html = createMarkupFragment(text);
            const newProductsSection = html.querySelector(FILTER_SELECTORS.products);

            if( !newProductsSection ){
                return;
            }
            
            productsSection.innerHTML = newProductsSection.innerHTML;

            updateURLState(searchParams);
            updatePagination(searchParams);
            this.close();

        });
    }

}

if( !customElements.get('sorting-dropdown') ){
    customElements.define('sorting-dropdown', SortingDropdown);
}


class ProductsPagination extends HTMLElement {
    constructor(){
        super();

        this.productsSelector = FILTER_SELECTORS.products;
        this.isLoading = false;
        this.observer = null;
        this.handlePaginationClick = this.onPaginationClick.bind(this);
    }

    connectedCallback(){
        this.addEventListener('click', this.handlePaginationClick);
        this.setupInfiniteScroll();
    }

    disconnectedCallback(){
        this.removeEventListener('click', this.handlePaginationClick);
        this.teardownInfiniteScroll();
    }

    onPaginationClick = (event) => {
        var link = event.target.closest('a');

        if( !link || !this.contains(link) ){
            return;
        }

        event.preventDefault();
        this.loadPage(link.getAttribute('href'), { append: false, updateUrl: true, scrollToTop: true });
    }

    setupInfiniteScroll = () => {
        if( this.dataset.infiniteScroll !== 'true' ){
            return;
        }

        var trigger = this.getStatusTrigger();

        if( !trigger ){
            return;
        }

        this.observer = new IntersectionObserver((entries) => {
            for( let entry of entries ){
                if( entry.isIntersecting ){
                    var nextLink = this.querySelector('.next a');

                    if( nextLink ){
                        this.loadPage(nextLink.getAttribute('href'), { append: true, updateUrl: false, scrollToTop: false });
                    }
                }
            }
        }, {
            rootMargin: '320px 0px'
        });

        this.observer.observe(trigger);
    }

    teardownInfiniteScroll = () => {
        if( this.observer ){
            this.observer.disconnect();
            this.observer = null;
        }
    }

    getProductsSection = () => {
        return this.closest(this.productsSelector) || document.querySelector(this.productsSelector);
    }

    getStatusTrigger = () => {
        var productsSection = this.getProductsSection();

        if( !productsSection ){
            return null;
        }

        return productsSection.querySelector('.products-infinite-scroll-trigger');
    }

    getStatusElement = () => {
        var productsSection = this.getProductsSection();

        if( !productsSection ){
            return null;
        }

        return productsSection.querySelector('.products-infinite-scroll-status');
    }

    setStatus = (text, isComplete = false) => {
        var statusElement = this.getStatusElement();

        if( !statusElement ){
            return;
        }

        statusElement.textContent = text || '';

        if( isComplete ){
            statusElement.classList.add('is-complete');
        }
        else{
            statusElement.classList.remove('is-complete');
        }
    }

    loadPage = (href, options = {}) => {
        if( !href || this.isLoading ){
            return;
        }

        var { append = false, updateUrl = true, scrollToTop = false } = options;
        var productsSection = this.getProductsSection();
        var preserveStatus = false;

        if( !productsSection ){
            return;
        }

        this.isLoading = true;
        this.classList.add('is-loading');

        if( append ){
            this.setStatus(productsSection.dataset.loadingText || '');
        }

        var searchParams = href.replace(window.location.pathname + '?', '');

        fetch(`${window.location.pathname}?${searchParams}`)
            .then(response => {
                return response.text()
            })
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const newProductsSection = html.querySelector(this.productsSelector);

                if( !newProductsSection ){
                    return;
                }

                if( append ){
                    const currentList = productsSection.querySelector('.products-list');
                    const newList = newProductsSection.querySelector('.products-list');
                    const newPagination = newProductsSection.querySelector('products-pagination');

                    if( currentList && newList ){
                        currentList.insertAdjacentHTML('beforeend', newList.innerHTML);
                    }

                    if( newPagination ){
                        this.outerHTML = newPagination.outerHTML;
                    }
                    else{
                        var trigger = this.getStatusTrigger();
                        if( trigger ){
                            trigger.remove();
                        }

                        preserveStatus = true;
                        this.setStatus(productsSection.dataset.loadedAllText || '', true);
                        this.remove();
                    }

                    saveInfiniteScrollState();

                    return;
                }

                productsSection.innerHTML = newProductsSection.innerHTML;
                bindInfiniteScrollStateTracking();
                saveInfiniteScrollState();

                if( updateUrl ){
                    updateURLState(searchParams)
                }

                if( scrollToTop ){
                    document.querySelector(FILTER_SELECTORS.sectionProducts)?.scrollIntoView({
                        behavior: 'auto'
                    });
                }
            })
            .finally(() => {
                this.isLoading = false;
                this.classList.remove('is-loading');

                if( append && !preserveStatus ){
                    this.setStatus('');
                }
            });
    }
}

if( !customElements.get('products-pagination') ){
    customElements.define('products-pagination', ProductsPagination);
}

if( 'scrollRestoration' in history ){
    history.scrollRestoration = 'manual';
}

restoreInfiniteScrollState();
bindInfiniteScrollStateTracking();
